import * as React from 'react';
export var NotificationsItem = function (_a) {
    var close = _a.close, _b = _a.kind, kind = _b === void 0 ? 'info' : _b, title = _a.title, children = _a.children;
    return (React.createElement("div", { className: "notification ".concat(kind) },
        React.createElement("div", { className: "notification-content" },
            title && React.createElement("div", { className: "notification-title" }, title),
            React.createElement("div", { className: "notification-description" }, children)),
        React.createElement("div", { className: "notification-close", onClick: close })));
};
//# sourceMappingURL=NotificationsItem.js.map